import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { TABS_PATIENT_PORTAL } from '../../../constants';
import LabTestResultCard from './LabTestResultCard';
import FamilyHistoryCard from './FamilyHistoryCard';
import SocialHistoryCard from './SocialHistoryCard';
import HealthRecordCard from './HealthRecordCard';
import ImmunizationCard from './ImmunizationCard';
import MedicationCard from './MedicationCard';
import ConditionCard from './ConditionCard';
import EncounterCard from './EncounterCard';
import ProcedureCard from './ProcedureCard';
import AllergiesCard from './AllergieCard';
import ActivityLog from './ActivityLog';
import styles from './index.styl';

const {
  MEDICATIONS,
  ALLERGIES,
  CONDITIONS,
  IMMUNIZATIONS,
  LAB_TEST_RESULT,
  FAMILY_HISTORY,
  ENCOUNTERS,
  SOCIAL_HISTORY,
  HEALTH_RECORD,
  ACTIVITY_LOG,
  PROCEDURES,
} = TABS_PATIENT_PORTAL;

const Card = ({ entity, activeTab, formatMessage, isInactive }) => {
  const isActivityLogTab = ACTIVITY_LOG === activeTab;
  const handleCardView = useMemo(
    () => () => {
      switch (activeTab) {
        case MEDICATIONS:
          return (
            <MedicationCard
              entity={entity}
              isInactive={isInactive}
              formatMessage={formatMessage}
            />
          );
        case ACTIVITY_LOG:
          return <ActivityLog entity={entity} formatMessage={formatMessage} />;
        case ALLERGIES:
          return (
            <AllergiesCard entity={entity} formatMessage={formatMessage} />
          );
        case IMMUNIZATIONS:
          return <ImmunizationCard entity={entity} />;
        case CONDITIONS:
          return <ConditionCard entity={entity} />;
        case LAB_TEST_RESULT:
          return <LabTestResultCard entity={entity} />;
        case FAMILY_HISTORY:
          return <FamilyHistoryCard entity={entity} />;
        case ENCOUNTERS:
          return (
            <EncounterCard entity={entity} formatMessage={formatMessage} />
          );
        case SOCIAL_HISTORY:
          return <SocialHistoryCard entity={entity} />;
        case HEALTH_RECORD:
          return (
            <HealthRecordCard entity={entity} formatMessage={formatMessage} />
          );
        case PROCEDURES:
          return (
            <ProcedureCard entity={entity} formatMessage={formatMessage} />
          );
      }
    },
    [activeTab, entity],
  );
  return (
    <div
      className={cn(styles.root, {
        [styles.activityLogRoot]: isActivityLogTab,
      })}
    >
      {handleCardView()}
    </div>
  );
};

Card.propTypes = {
  entity: PropTypes.object,
  isInactive: PropTypes.bool,
  activeTab: PropTypes.string,
  formatMessage: PropTypes.func,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/index.jsx